<!--<hr class="hr-top">-->
<div (mouseenter)="mouseEntered()" (mouseleave)="mouseLeft()"
     (click)="openChat()"
     class="chat-item pointer d-flex justify-content-start align-items-center"
>
    <div class="my-5  d-flex justify-content-start align-items-center">
        <div class="mx-3 chat-image">
            <base64-image [borderRadiusRem]="2" [base64String]="chatImageBase64"></base64-image>
            <span *ngIf="unreadMessageCount > 0"
                  class="position-absolute bottom-0 end-0 badge rounded-pill bg-danger">
                    {{unreadMessageCount}}
                <span class="visually-hidden">unread messages</span>
                </span>
        </div>
        <div class="ms-1">
            <div class="chat-name"
                 *ngIf="!otherGuy"
                 [class.placeholder]="!chat"
            >{{ chat?.name }}</div>
            <div class="chat-name"
                 *ngIf="otherGuy"
                 [class.placeholder]="!otherGuy"
            >{{ otherGuy?.display_name }}</div>
            <div class="last-message small">{{ lastMessageText }}</div>
        </div>
    </div>
<!--    <div id="container-stars" *ngIf="hovered">-->
<!--        <div id="stars"></div>-->
<!--    </div>-->

    <div id="glow" *ngIf="hovered">
        <div class="circle"></div>
        <div class="circle"></div>
    </div>
</div>
<!--<hr class="hr-bottom">-->
